import {
  OrthographicShapeState3D,
  ShapeState,
} from '../../cross-team-shared/annotation/shared/state/shape-state';
import { PointCloudShapeType } from '../../team-apis/otterdam/answers/point-cloud-answer';

export interface PolygonState3D extends OrthographicShapeState3D {
  type: Extract<PointCloudShapeType, 'polygon'>;
}

export function isPolygonState3D(shape: ShapeState): shape is PolygonState3D {
  return shape.type === 'polygon';
}
